export default {
  set (state, strategies) {
    state.strategies = strategies
  }
}
